<template>
  <v-dialog
    v-model="dialog"
    persistent
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    class="d-flex flex-column align-center"
  >
    <v-card max-width="500" style="margin:auto" class="pa-2 mb-4">
      <v-card-actions>
<v-btn elevation="0" fab color="error" small class="modal-default-button title mb-2" @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
      </v-card-actions>
      <v-card-text class="mt-2 subtitle-1">{{message}}</v-card-text>
      <v-card-text >
        Username *
        <v-text-field
          v-model="username"
          @focus="handleUsernameFocus"
          outlined
          placeholder="Enter your Username"
          :name="Math.random()"
          color="textinput"
        />
        Password *
        <v-text-field
          :type="showPassword ? 'text' : 'password'"
          v-model="password"
          outlined
          placeholder="Enter your password"
          @focus="handlePasswordFocus"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          autocomplete="new-password"
          :name="Math.random()"
          color="textinput"
        />
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-card-text class="d-inline red--text" v-if="warningError"
          >{{ warningError }}
          <v-btn
            elevation="0"
            v-if="warningError"
            @click="warningError = null"
            color="grey"
            class="d-inline loginButton"
            >OK</v-btn
          ></v-card-text
        >
        <v-btn
          elevation="0"
          v-if="!warningError"
          @click="adminAuth"
          color="blue"
          class="loginButton"
          >Authorise</v-btn
        >
      </v-card-actions>
    </v-card>
      <SimpleKeyboard
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="input"
    />
  </v-dialog>

</template>

<script>
import { Auth } from "aws-amplify";
import SimpleKeyboard from "../components/SimpleKeyboard";
import { USERROLE } from '../common/constants';
import { mapGetters } from 'vuex'

export default {
  name: "UserRoleValidationModal",
  props: {
    successCallback: Function,
  },
  data: function () {
    return {
      dialog: false,
      message: "Please enter the credential for validation purpose",
      title: "Admin consent form",
      username: "",
      password: "",
      showPassword: false,
      warningError: null,
      selectedInput: null,
      options: {
        color: "#425058",
        width: '80vw',
        zIndex: 999
      },
    };
  },
  computed: {
    ...mapGetters(['getVenueName']), 
    input: {
      get() {
        return this.selectedInput === "username"
          ? this.username
          : this.password;
      },
      set() {},
    },
  },
  components: {
    SimpleKeyboard,
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title || this.title;
      this.message = message || this.message;
      this.options = Object.assign(this.options, options);
    },
    close(){
      this.dialog = false
      this.username = ''
      this.password = ''
      this.warningError = null
    },
    async adminAuth() {
      const currentUser = await Auth.signIn(this.username, this.password).catch(
        (err) => {
          this.warningError = err.message;
          return;
        }
      );
      // refresh the session to ensure current session is still the previous user
      const previousUser = await Auth.currentAuthenticatedUser();
      const { refreshToken } = previousUser.getSignInUserSession();
      previousUser.refreshSession(refreshToken, () => {});

      if (parseInt(currentUser?.attributes["custom:admin"]) === USERROLE.ADMIN && currentUser?.attributes["custom:venue"] === this.getVenueName ) {
        // it is admin, then pass admin's token to do re-print
        this.successCallback(currentUser.signInUserSession.accessToken.jwtToken);
        this.close()
      } else {
        // not admin
        this.warningError =
          "The user doesn't have permission to authorize re-print";
      }
    },
    handleUsernameFocus() {
      this.selectedInput = "username";
    },
    handlePasswordFocus() {
      this.selectedInput = "password";
    },
    onChange(input) {
      if (this.selectedInput === "username") {
        this.username = input;
      }
      if (this.selectedInput === "password") {
        this.password = input;
      }
    },
    onKeyPress() {},
  },
};
</script>
<style lang="sass">
.loginButton
  float: right
</style>